import * as amplitude from '@amplitude/analytics-browser'

type PlanFraming = 'day' | 'step'

// Null until `me` lands so no event carries a guessed arm.
let planFraming: PlanFraming | null = null
let identified: PlanFraming | null = null

// Noted while rendering, not in an effect: a child that tracks on mount in the
// same commit runs its effects first and would otherwise miss the arm.
export function noteAnalyticsPlanFraming(framing: PlanFraming) {
  planFraming = framing
}

// Re-stamped on every arm change: a plan switch changes it under the same user id.
export function identifyAnalyticsPlanFraming(framing: PlanFraming) {
  if (identified === framing) return
  identified = framing
  const identify = new amplitude.Identify()
  identify.set('planFraming', framing)
  amplitude.identify(identify)
}

export function clearAnalyticsPlanFraming() {
  planFraming = null
  identified = null
}

export function withPlanFraming(
  properties: Record<string, unknown>,
): Record<string, unknown> {
  return planFraming ? { planFraming, ...properties } : properties
}
